var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.devcDef, rules: _vm.rules }
        },
        [
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("财务类别")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "assetKindName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { disabled: "", type: "text" },
                      model: {
                        value: _vm.devcDef.assetKindName,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "assetKindName", $$v)
                        },
                        expression: "devcDef.assetKindName"
                      }
                    }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass:
                        "form-tips icon iconfont icon-chazhaobiaodanliebiao relation-icon",
                      attrs: { title: "选择" },
                      on: {
                        click: function($event) {
                          _vm.setAssetKind()
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("资产属性")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("el-form-item", { attrs: { prop: "assetNature" } }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.assetNatureMap[_vm.devcDef.assetNature]))
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c(
                "label",
                {
                  class: _vm.devcDef.deprMethodCode != "NONE" ? "required" : ""
                },
                [_vm._v("使用年限(月)")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      prop: "durableLife",
                      rules: {
                        validator: _vm.checkDurableLife,
                        trigger: "blur"
                      }
                    }
                  },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { type: "number" },
                      model: {
                        value: _vm.devcDef.durableLife,
                        callback: function($$v) {
                          _vm.$set(_vm.devcDef, "durableLife", $$v)
                        },
                        expression: "devcDef.durableLife"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "content-caption dashed" }, [
            _c("span", [_vm._v("折旧与分摊规则")])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("规则名称")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.deprSpecName || ""))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("规则编码")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.devcDef.deprSpecCode || ""))])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5647a34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5647a34","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcDef/MerchtDevcDefFiscalSave.vue
// module id = 2414
// module chunks = 0